import { globalAuthContext } from '@headbox-ui/auth-hook'
import * as Sentry from '@sentry/browser'
import React, { useEffect } from 'react'
import { render } from 'react-dom'
import { Authenticator, GqlClient, Header } from './Components'
import { JWT_COOKIE_NAME, LOGGING, REFRESH_TOKEN_COOKIE_NAME, ROOT, SELF_SERVE_SERVICE } from './Constants'
import { sentryBrowserOptions } from './Constants/Sentry/browserOptions'
import { useGlobalState } from './Store'

declare global {
  interface Window { Application: { headerAppRelease: string }, SENTRY_RELEASE: { id: string } }
}

if (LOGGING) {
  Sentry.init(sentryBrowserOptions)

  // Keep a record of the Header app's release so Sentry can use the correct release
  // if another application needs to use the Header Sentry client.
  window.Application = { headerAppRelease: window.SENTRY_RELEASE?.id }
}
globalAuthContext.set({
  refreshTokenCookie: REFRESH_TOKEN_COOKIE_NAME,
  sessionTokenCookie: JWT_COOKIE_NAME,
  rootService: ROOT,
  selfServeService: SELF_SERVE_SERVICE
})

const root: Element = document.querySelector('header-app-root')

const App = (): JSX.Element => {
  const [, setSession] = useGlobalState('withoutNav')

  useEffect(() => {
    setSession(root.getAttribute('withoutNav') !== null)
  }, [])

  return (
    <GqlClient>
      <Authenticator>
        <Header />
      </Authenticator>
    </GqlClient>
  )
}
render(<App />, root)
